export class ZeroEtlTargetTable {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "catalogAccountId",
            "baseName": "catalogAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "catalogRegion",
            "baseName": "catalogRegion",
            "type": "string",
            "format": ""
        },
        {
            "name": "icebergNamespace",
            "baseName": "icebergNamespace",
            "type": "string",
            "format": ""
        },
        {
            "name": "icebergTable",
            "baseName": "icebergTable",
            "type": "string",
            "format": ""
        },
        {
            "name": "tableFormat",
            "baseName": "tableFormat",
            "type": "ZeroEtlTableFormat",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "ZeroEtlTargetTableStatus",
            "format": ""
        },
        {
            "name": "policyId",
            "baseName": "policyId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "resourceDetails",
            "baseName": "resourceDetails",
            "type": "ResourceDetails",
            "format": ""
        },
        {
            "name": "vaultId",
            "baseName": "vaultId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "lastJobId",
            "baseName": "lastJobId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "lastJobPointInTime",
            "baseName": "lastJobPointInTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "syncedSourceTables",
            "baseName": "syncedSourceTables",
            "type": "number",
            "format": ""
        },
        {
            "name": "totalSourceTables",
            "baseName": "totalSourceTables",
            "type": "number",
            "format": ""
        },
        {
            "name": "completeThroughPit",
            "baseName": "completeThroughPit",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "completeThroughSnapshotId",
            "baseName": "completeThroughSnapshotId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "updatedTime",
            "baseName": "updatedTime",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return ZeroEtlTargetTable.attributeTypeMap;
    }
    constructor() {
    }
}
